import React from "react";
import { MapPin, CalendarDays, Route, Smartphone } from "lucide-react";

const SidebarMenu = ({
  user,
  selectedCompany,
  editMode,
  setEditMode,
  readerMode,
  setReaderMode,
  setMopMode,
  editLoctagMode,
  setEditLoctagMode,
  addMode,
  setAddMode,
  drawMode,
  setDrawMode,
  locationSettingsMode,
  setLocationSettingsMode,
  usersMode,
  setUsersMode,
  cleanRouteMode,
  setCleanRouteMode,
  lifeViewMode,
  setLifeViewMode,
  calendarMode,
  setCalendarMode,
  mobilMode,
  setMobilMode,
  mobilSubMode,
  setMobilSubMode,
  onOpenDeviceSelector,
  registrationDevice,
  isReading,
  onStartReading,
  onStopReading,
}) => {
  const isCleaner = user?.type === "cleaner";

  const turnOffDesktopModes = () => {
    setEditMode(false);
    setLocationSettingsMode(false);
    setUsersMode(false);
    setCleanRouteMode(false);
    setLifeViewMode(false);
    setCalendarMode(false);
    setReaderMode(false);
    setDrawMode(false);
    setMopMode(false);
    if (setEditLoctagMode) setEditLoctagMode(false);
    if (setAddMode) setAddMode(false);
  };

  const activateMobile = (subMode) => {
    turnOffDesktopModes();
    setMobilMode(true);
    setMobilSubMode(subMode);
  };

  const handleCalendarClick = () => {
    const next = !calendarMode;
    setCalendarMode(next);
    if (next) {
      setCleanRouteMode(false);
        setEditMode(false);
      setLocationSettingsMode(false);
      setUsersMode(false);
      setMobilMode(false);
      setMobilSubMode(null);
    }
  };

  const handleCleanRouteClick = () => {
    setCleanRouteMode((prev) => !prev);
    setLifeViewMode(false);
    setCalendarMode(false);
    setUsersMode(false);
    setEditMode(false);
    setLocationSettingsMode(false);
    setAddMode(false);
    setDrawMode(false);
    setReaderMode(false);
    setEditLoctagMode(false);
    setMopMode(false);
    setMobilMode(false);
    setMobilSubMode(null);
  };

  const handleLifeViewClick = () => {
    setLifeViewMode((prev) => !prev);
    setCleanRouteMode(false);
    setCalendarMode(false);
    setUsersMode(false);
    setEditMode(false);
    setLocationSettingsMode(false);
    setAddMode(false);
    setDrawMode(false);
    setReaderMode(false);
    setEditLoctagMode(false);
    setMopMode(false);
    setMobilMode(false);
    setMobilSubMode(null);
  };

  const handleMobileCleanRoute = () => {
    if (mobilMode && mobilSubMode === "clean-route") {
      setMobilMode(false);
      setMobilSubMode(null);
    } else {
      activateMobile("clean-route");
    }
  };

  const handleMobileCalendar = () => {
    if (mobilMode && mobilSubMode === "calendar") {
      setMobilMode(false);
      setMobilSubMode(null);
    } else {
      activateMobile("calendar");
    }
  };

  const NavButton = ({ icon: Icon, label, active, onClick, disabled = false }) => (
    <div className="relative group">
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={label}
        className={`relative w-full h-14 flex items-center justify-center transition-colors ${
          disabled
            ? "text-slate-600 cursor-not-allowed"
            : active
            ? "text-teal-400 bg-slate-800"
            : "text-slate-400 hover:text-slate-100 hover:bg-slate-800"
        }`}
      >
        {active && (
          <span className="absolute left-0 top-2 bottom-2 w-0.5 bg-teal-400 rounded-r" />
        )}
        <Icon size={20} strokeWidth={1.75} />
      </button>
      <span className="pointer-events-none absolute left-full top-1/2 -translate-y-1/2 ml-2 px-2.5 py-1 bg-slate-800 text-slate-100 text-xs font-medium rounded shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-150 z-[300] border border-slate-700">
        {label}
      </span>
    </div>
  );

  const GroupLabel = ({ children }) => (
    <div className="px-1 pt-3 pb-1 text-[10px] uppercase tracking-wider text-slate-500 text-center select-none">
      {children}
    </div>
  );

  return (
    <aside className="w-16 bg-slate-900 text-slate-100 flex flex-col border-r border-slate-800 overflow-visible">
      {/* Mobil – csak mobilon, cleanernek Clean route + Calendar */}
      <div className="md:hidden flex flex-col">
        {isCleaner ? (
          <>
            <GroupLabel>Mobil</GroupLabel>
            <NavButton
              icon={MapPin}
              label="Clean route"
              active={mobilMode && mobilSubMode === "clean-route"}
              onClick={handleMobileCleanRoute}
            />
            <NavButton
              icon={CalendarDays}
              label="Calendar"
              active={mobilMode && mobilSubMode === "calendar"}
              onClick={handleMobileCalendar}
            />
          </>
        ) : (
          <NavButton
            icon={Smartphone}
            label="Mobil"
            active={mobilMode}
            onClick={() => setMobilMode((p) => !p)}
          />
        )}
      </div>

      {/* Desktop menü */}
      <div className="hidden md:flex md:flex-col flex-1">
        <GroupLabel>Dashboard</GroupLabel>
        <NavButton
          icon={MapPin}
          label="Life View"
          active={lifeViewMode}
          onClick={handleLifeViewClick}
        />
        <NavButton
          icon={CalendarDays}
          label="Calendar"
          active={calendarMode}
          onClick={handleCalendarClick}
        />
        <NavButton
          icon={Route}
          label="Clean route"
          active={cleanRouteMode}
          onClick={handleCleanRouteClick}
        />
      </div>
    </aside>
  );
};

export default SidebarMenu;
